/* eslint-disable */
import { Link } from 'react-router-dom';
import imperialTobacco from '../../../assets/img/imperial_tobacco.png';

import './logos.css';

const UKLogo = () => (
  <div className="container-fluid">
    <div className="row">
      <div className="col-lg-offset-1 col-lg-22 col-md-offset-1 col-md-22">
        <div className="brands" style={ { textAlign: "left" } }>
          <Link to="/" title="Imperial Brands">
            <img src={imperialTobacco} alt="Imperial Brands"/>
          </Link>
        </div>
        <div className="col-lg-4"/>
      </div>
    </div>
  </div>
);

export default () => <UKLogo/>;
